import { AxiosInstance } from "axios";

export const MasterDataEventService = (axiosInstance: AxiosInstance) => {
  const apiBaseUrl = "api/masterdata-event";

  return {
    getByEventId: async (eventId: string) => {
      return await axiosInstance.get(`${apiBaseUrl}/${eventId}`).then((result) => result.data);
    },
  };
};
